var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("section", { staticClass: "masthead masthead--inner" }, [
        _c("div", { staticClass: "in" }, [
          _c(
            "div",
            {
              staticClass: "masthead__slide",
              staticStyle: {
                background:
                  'rgba(0, 0, 0, 0) url("../../../../../../static/styles/mailkit/img/banner.jpg") no-repeat scroll center center / cover',
                width: "100%",
                display: "inline-block"
              }
            },
            [
              _c("div", { staticClass: "masthead__caption" }, [
                _c("h3", [
                  _vm._v("Congratulations!"),
                  _c("br"),
                  _vm._v(
                    "A member of our support team will be in contact within 1 hour to arrange the necessary paperwork"
                  )
                ])
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("h1", [
        _vm._v(
          "Did you know we can also support you with various other solutions? Please select any of the options below for further support."
        )
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "helpIcons" }, [
        _c("div", { staticClass: "in container" }, [
          _c("div", { staticClass: "helpIcons__wrap" }, [
            _c("div", { staticClass: "helpIcons__main" }, [
              _c("div", { staticClass: "in" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "https://themailingexpert.com/helpdesk/#mailandfranking"
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src:
                          "https://themailingexpert.com/wp-content/themes/ctmk/assets/img/letterbig.png"
                      }
                    }),
                    _vm._v(" "),
                    _c("h4", [_vm._v("MAIL & FRANKING")])
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "helpIcons__blocks" }, [
              _c("div", { staticClass: "ctaBlocks__block" }, [
                _c("div", { staticClass: "in" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://themailingexpert.com/helpdesk/#xray"
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src:
                            "https://themailingexpert.com/wp-content/uploads/2018/07/XRAY-1.png"
                        }
                      }),
                      _vm._v(" "),
                      _c("h4", [_vm._v("X RAY")])
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ctaBlocks__block" }, [
                _c("div", { staticClass: "in" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "https://themailingexpert.com/helpdesk/#letteropeners"
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src:
                            "https://themailingexpert.com/wp-content/uploads/2018/07/letter-openers.png"
                        }
                      }),
                      _vm._v(" "),
                      _c("h4", [_vm._v("LETTER OPENERS")])
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ctaBlocks__block" }, [
                _c("div", { staticClass: "in" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "https://themailingexpert.com/helpdesk/#insertingmachines"
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src:
                            "https://themailingexpert.com/wp-content/uploads/2018/07/inserting-machines.png"
                        }
                      }),
                      _vm._v(" "),
                      _c("h4", [_vm._v("INSERTING MACHINES")])
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ctaBlocks__block" }, [
                _c("div", { staticClass: "in" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "https://themailingexpert.com/helpdesk/#mfdandprint"
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src:
                            "https://themailingexpert.com/wp-content/uploads/2018/07/mdf-print.png"
                        }
                      }),
                      _vm._v(" "),
                      _c("h4", [_vm._v("MFD & PRINT DEVICES")])
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ctaBlocks__block" }, [
                _c("div", { staticClass: "in" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "https://themailingexpert.com/helpdesk/#hybridmail"
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src:
                            "https://themailingexpert.com/wp-content/uploads/2018/07/hydbrid-mail.png"
                        }
                      }),
                      _vm._v(" "),
                      _c("h4", [_vm._v("HYBRID MAIL SOLUTIONS")])
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ctaBlocks__block" }, [
                _c("div", { staticClass: "in" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "https://themailingexpert.com/helpdesk/#digitisationandscan"
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src:
                            "https://themailingexpert.com/wp-content/uploads/2018/07/scanning.png"
                        }
                      }),
                      _vm._v(" "),
                      _c("h4", [_vm._v("SCANNING SOLUTIONS")])
                    ]
                  )
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64ee5550", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64ee5550","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Order/Success.vue
// module id = null
// module chunks = 